import React, { useState, useEffect } from "react"; // ✅ add useEffect here
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

const DoctorSelfAttendance = () => {
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("P");
  const [loading, setLoading] = useState(false);
  const [selectedDoctors, setSelectedDoctors] = useState([]); // ✅ multiple doctors
  const navigate = useNavigate();

  // 🔒 Redirect if not logged in
  useEffect(() => {
    const isAuthed = sessionStorage.getItem("staff_portal_authed");
    if (!isAuthed) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "Please log in to continue.",
        confirmButtonText: "Go to Login",
        confirmButtonColor: "#007bff",
      }).then(() => {
        navigate("/attendance-login", { replace: true });
      });
    }
  }, [navigate]);
   
  const statusOptions = [
    { value: "P", label: "✅ Present (P)" },
    { value: "A", label: "❌ Absent (A)" },
    { value: "L", label: "🌴 Leave (L)" },
    { value: "D/O", label: "🕊️ Day Off (D/O)" },
  ];

  const designationOptions = [
    "Assistant Professor",
    "Senior Registrar",
    "Medical Officer",
    "Post Graduate",
  ];

  // load staff list
  const loadDoctors = async () => {
    try {
      const res = await axios.get("https://ricgop.online/backend/staff/api/get-staff.php");
      if (Array.isArray(res.data)) {
        const formatted = res.data.map((doc) => ({
          value: doc.name,
          label: `${doc.name} — ${doc.designation || ""}`,
          designation: doc.designation || "",
        }));
        setDoctors(formatted);
      }
    } catch (err) {
      console.error(err);
      Swal.fire("❌ Error", "Failed to load doctor list", "error");
    }
  };


  const handleLogout = () => {
  Swal.fire({
    icon: "question",
    title: "Logout?",
    text: "Are you sure you want to log out?",
    showCancelButton: true,
    confirmButtonText: "Yes, Logout",
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
  }).then((result) => {
    if (result.isConfirmed) {
      // Clear session and navigate cleanly
      sessionStorage.removeItem("staff_portal_authed");

      Swal.fire({
        icon: "success",
        title: "Logged Out",
        text: "You have been logged out successfully.",
        showConfirmButton: false,
        timer: 1000,
      });

      // Give Swal time to close before navigating
      setTimeout(() => {
        navigate("/attendance-login", { replace: true });
      }, 1000);
    }
  });
};


  useEffect(() => {
    loadDoctors();
    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);
  }, []);

  // auto-detect category from designation when selecting existing doctor
  const handleDoctorSelect = (option) => {
    setSelectedDoctor(option);
    if (!option) return setSelectedCategory("");
    const desig = option.designation?.toLowerCase() || "";
    if (desig.includes("assistant professor")) setSelectedCategory("AP");
    else if (desig.includes("senior registrar")) setSelectedCategory("SR");
    else if (desig.includes("medical officer")) setSelectedCategory("MO");
    else if (desig.includes("post graduate") || desig.includes("pg"))
      setSelectedCategory("PG");
    else setSelectedCategory("");
  };

 // -------------------------
// Add New Staff — Enhanced UI
// -------------------------
const handleAddStaff = async () => {
  const { value: formValues } = await Swal.fire({
    title: "➕ Add New Staff Member",
    html: `
      <div style="text-align:left; font-family: 'Inter', sans-serif;">

        <div style="margin-bottom:16px;">
          <label style="font-weight:600; color:#004085; display:block; margin-bottom:6px;">
            Full Name <span style="color:red;">*</span>
          </label>
          <input id="swal-name" 
                 class="swal2-input" 
                 placeholder="Enter full name"
                 style="width:100%; border-radius:10px; border:1px solid #ced4da; padding:10px; height:42px; font-size:14px;">
        </div>

        <div style="margin-bottom:16px;">
          <label style="font-weight:600; color:#004085; display:block; margin-bottom:6px;">
            Designation <span style="color:red;">*</span>
          </label>
          <select id="swal-designation" 
                  class="swal2-input"
                  style="width:100%; border-radius:10px; border:1px solid #ced4da; padding:10px; height:42px; font-size:14px;">
            <option value="">-- Select Designation --</option>
            ${designationOptions
              .map((d) => `<option value="${d}">${d}</option>`)
              .join("")}
          </select>
        </div>

        <div style="margin-bottom:6px;">
          <label style="font-weight:600; color:#004085; display:block; margin-bottom:6px;">
            Category
          </label>
          <select id="swal-category" 
                  class="swal2-input" 
                  style="width:100%; border-radius:10px; border:1px solid #ced4da; padding:10px; height:42px; font-size:14px;">
            <option value="">-- Select Category --</option>
            <option value="AP">AP – Assistant Professor</option>
            <option value="SR">SR – Senior Registrar</option>
            <option value="MO">MO – Medical Officer</option>
            <option value="PG">PG – Post Graduate</option>
          </select>
        </div>

      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "💾 Save Staff",
    confirmButtonColor: "#007bff",
    cancelButtonColor: "#6c757d",
    focusConfirm: false,
    background: "#fff",
    width: 500,
    customClass: {
      popup: "shadow-lg rounded-4 p-3",
      title: "fw-bold text-primary",
    },

    didOpen: () => {
      const desigSelect = document.getElementById("swal-designation");
      const catSelect = document.getElementById("swal-category");
      if (!desigSelect || !catSelect) return;

      // Map designations to categories
      const mapToCategory = (val) => {
        const v = val.toLowerCase();
        if (v.includes("assistant professor")) return "AP";
        if (v.includes("senior registrar")) return "SR";
        if (v.includes("medical officer")) return "MO";
        if (v.includes("post graduate") || v.includes("pg")) return "PG";
        return "";
      };

      const handler = () => {
        const c = mapToCategory(desigSelect.value);
        if (c) catSelect.value = c;
      };

      desigSelect.addEventListener("change", handler);
      handler();
    },

    preConfirm: () => {
      const name = (document.getElementById("swal-name")?.value || "").trim();
      const designation = (document.getElementById("swal-designation")?.value || "").trim();
      const category = (document.getElementById("swal-category")?.value || "").trim();

      if (!name || !designation) {
        Swal.showValidationMessage("⚠️ Please fill in required fields: Name and Designation");
        return false;
      }
      return { name, designation, category };
    },
  });

  if (formValues) {
    try {
      const res = await axios.post(
        "https://ricgop.online/backend/staff/api/add-staff.php",
        formValues,
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data?.success) {
        Swal.fire({
          icon: "success",
          title: "✅ Staff Added",
          text: `${formValues.name} added successfully.`,
          confirmButtonColor: "#007bff",
        });
        await loadDoctors();
      } else {
        Swal.fire("❌ Error", res.data?.message || "Failed to add staff", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("❌ Error", "Unable to add staff", "error");
    }
  }
};

// -------------------------
  // Multi Attendance Submission
  // -------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedDoctors.length === 0 || !selectedCategory) {
      Swal.fire("⚠️ Missing Info", "Please select at least one doctor and category", "warning");
      return;
    }

    setLoading(true);
    try {
      const now = new Date(selectedDate);
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();
      const monthLabel = now.toLocaleString("default", { month: "long", year: "numeric" });
      const department = "doctorsattendance";

      const viewUrl = `https://ricgop.online/backend/staff/api/view-roster.php?department=${department}&category=${selectedCategory}&month=${encodeURIComponent(
        monthLabel
      )}`;
      const existingRes = await axios.get(viewUrl);

      let mergedDays = {};
      if (existingRes.data?.success && existingRes.data?.data) {
        const roster = Object.values(existingRes.data.data)[0];
        mergedDays = roster?.staffs || {};
      }

      const numDays = new Date(year, month + 1, 0).getDate();

      // ✅ Loop through all selected doctors
      for (const doc of selectedDoctors) {
        const doctorName = doc.value;
        if (!mergedDays[doctorName]) mergedDays[doctorName] = {};

        const tempAttendance = {};
        for (let i = 1; i <= numDays; i++) {
          const date = new Date(year, month, i);
          const isSunday = date.getDay() === 0;
          tempAttendance[i] = mergedDays[doctorName][i]
            ? mergedDays[doctorName][i]
            : isSunday
            ? "D/O"
            : "A";
        }

        // Mark the selected date
        tempAttendance[day] = selectedStatus;
        mergedDays[doctorName] = tempAttendance;
      }

      const payload = {
        department,
        category: selectedCategory,
        month: monthLabel,
        numDays,
        days: mergedDays,
      };

      const saveRes = await axios.post(
        "https://ricgop.online/backend/staff/api/add-roster.php",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (saveRes.data?.success) {
        Swal.fire(
          "✅ Attendance Marked",
          `${selectedDoctors.length} staff marked "${selectedStatus}" for ${selectedDate}.`,
          "success"
        );
      } else {
        Swal.fire("❌ Error", saveRes.data?.message || "Failed to save attendance", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("❌ Error", "Unable to mark attendance", "error");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div
      className="min-vh-100 d-flex justify-content-center align-items-center"
      style={{
        background: "linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 50%, #e0f7fa 100%)",
        padding: "50px 0",
      }}
    >
      <div
        className="p-5 shadow-lg rounded-4 border bg-white position-relative"
        style={{
          maxWidth: "650px",
          width: "95%",
          backdropFilter: "blur(10px)",
          background: "rgba(255,255,255,0.93)",
        }}
      >
        {/* Header */}
        <div className="text-center mb-4">
          <img
            src="/assets/img/logo/new-logo.png"
            alt="Hospital Logo"
            style={{
              width: "90px",
              height: "90px",
              objectFit: "contain",
              borderRadius: "50%",
              boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
              marginBottom: "10px",
            }}
          />
          <h2 className="fw-bold text-primary mt-2">Mark Attendance</h2>
          <p className="text-muted mb-0 fw-medium">
            Rawalpindi Institute of Cardiology — Staff Portal
          </p>
        </div>

          {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-3 position-relative">
           <div className="d-flex justify-content-end align-items-center mb-2">
  <button
    type="button"
    onClick={handleAddStaff}
    className="btn btn-sm btn-outline-success rounded-pill px-3 py-1 fw-semibold"
  >
    ➕ Add New Staff
  </button>
</div>
            <label className="form-label fw-semibold text-secondary mb-2">
              👨‍⚕️ Select Doctor(s)
            </label>

           <Select
  options={doctors}
  value={selectedDoctors}
  onChange={(selected) => {
    setSelectedDoctors(selected);

    if (selected && selected.length > 0) {
      const firstDoctor = selected[0]; // use the first selected doctor
      const desig = firstDoctor.designation?.toLowerCase() || "";
      if (desig.includes("assistant professor")) setSelectedCategory("AP");
      else if (desig.includes("senior registrar")) setSelectedCategory("SR");
      else if (desig.includes("medical officer")) setSelectedCategory("MO");
      else if (desig.includes("post graduate") || desig.includes("pg"))
        setSelectedCategory("PG");
      else setSelectedCategory("");
    } else {
      setSelectedCategory("");
    }
  }}
  isMulti
  isSearchable
  placeholder="Search or select doctor(s)..."
  classNamePrefix="select"
/>

          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-secondary">🏥 Category</label>
            <select
              className="form-select shadow-sm rounded-3"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="">-- Select Category --</option>
              <option value="AP">AP – Assistant Professor</option>
              <option value="SR">SR – Senior Registrar</option>
              <option value="MO">MO – Medical Officer</option>
              <option value="PG">PG – Post Graduate</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-secondary">📅 Date</label>
            <input
              type="date"
              className="form-control shadow-sm rounded-3"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-secondary">🗓️ Status</label>
            <Select
              options={statusOptions}
              value={statusOptions.find((s) => s.value === selectedStatus)}
              onChange={(option) => setSelectedStatus(option.value)}
              classNamePrefix="select"
            />
          </div>

          <div className="text-center mt-4 d-flex flex-column gap-3">
            <button
              type="submit"
              className="btn btn-primary px-5 py-2 rounded-pill shadow-sm fw-semibold"
              disabled={loading}
            >
              {loading ? "Saving..." : "🕒 Mark Attendance"}
            </button>

            <button
              type="button"
              className="btn btn-outline-primary px-5 py-2 rounded-pill fw-semibold"
              onClick={() => navigate("/view-attendance")}
            >
              📊 View Attendance Sheet
            </button>

            <button
              type="button"
              className="btn btn-outline-danger px-5 py-2 rounded-pill fw-semibold"
              onClick={handleLogout}
            >
              🚪 Logout
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .btn-primary {
          background: linear-gradient(90deg, #007bff, #00b4d8);
          border: none;
          transition: all 0.2s ease;
        }
        .btn-primary:hover {
          transform: translateY(-2px);
          background: linear-gradient(90deg, #0056b3, #0096c7);
        }
        .btn-outline-primary {
          border: 2px solid #007bff;
          color: #007bff;
          background: #fff;
          transition: all 0.3s ease;
        }
        .btn-outline-primary:hover {
          background: #007bff;
          color: #fff;
          transform: translateY(-2px);
        }
        /* Make Swal inputs look consistent */
        .swal2-container .swal2-popup .swal2-input {
          border-radius: 8px !important;
          padding: 10px !important;
          font-size: 14px !important;
          height: auto !important;
        }
        .swal2-container .swal2-popup select.swal2-input {
          height: 42px !important;
        }
      `}</style>
    </div>
  );
};

export default DoctorSelfAttendance;
